import {
  hideSettingsDialog,
  hideVirtualBackgroundDialog,
  SessionMethodsCore,
  showSettingsDialog,
  showVirtualBackgroundDialog,
  startScreenSharing,
  stopScreenSharing,
  updateAudioInputDeviceState,
  updateAudioOutputDevice,
  updateVideoInputDeviceState,
  useBaseStore,
} from '@cometchat/calls-sdk-core';
import {
  setVirtualBackgroundBlurLevel,
  setVirtualBackgroundImage,
  useVirtualBackgroundStore,
} from '../virtual-background/state';
import type { CallConstants } from './v4/constants';

export class SessionMethods extends SessionMethodsCore {
  public static startScreenSharing() {
    startScreenSharing();
  }

  public static stopScreenSharing() {
    stopScreenSharing();
  }

  public static showSettingsDialog() {
    showSettingsDialog();
  }

  public static hideSettingsDialog() {
    hideSettingsDialog();
  }

  public static showVirtualBackgroundDialog() {
    showVirtualBackgroundDialog();
  }

  public static hideVirtualBackgroundDialog() {
    hideVirtualBackgroundDialog();
  }

  public static getAudioInputDevices() {
    return useBaseStore.getState().audioInputDevices;
  }

  public static getAudioOutputDevices() {
    return useBaseStore.getState().audioOutputDevices;
  }

  public static getVideoInputDevices() {
    return useBaseStore.getState().videoInputDevices;
  }

  // TODO: Recheck the implementation of this method
  public static setAudioInputDevice(deviceId: string) {
    const audioInputDevices = useBaseStore.getState().audioInputDevices;
    const device = audioInputDevices.find(d => d.deviceId === deviceId);
    if (device) {
      updateAudioInputDeviceState(device);
    }
  }

  // TODO: Recheck the implementation of this method
  public static setAudioOutputDevice(deviceId: string) {
    const audioOutputDevices = useBaseStore.getState().audioOutputDevices;
    const device = audioOutputDevices.find(d => d.deviceId === deviceId);
    if (device) {
      updateAudioOutputDevice(deviceId);
    }
  }

  // TODO: Recheck the implementation of this method
  public static setVideoInputDevice(deviceId: string) {
    const videoInputDevices = useBaseStore.getState().videoInputDevices;
    const device = videoInputDevices.find(d => d.deviceId === deviceId);
    if (device) {
      updateVideoInputDeviceState(device);
    }
  }

  public static clearVirtualBackground() {
    useVirtualBackgroundStore.getState().setVirtualBackground('none');
  }

  public static setVirtualBackgroundBlurLevel(blurLevel: number) {
    setVirtualBackgroundBlurLevel(blurLevel);
  }

  public static setVirtualBackgroundImage(imageUrl: string) {
    setVirtualBackgroundImage(imageUrl);
  }

  // Legacy Methods

  /**
   * @deprecated use startScreenSharing() instead
   */
  public static startScreenShare() {
    this.startScreenSharing();
  }

  /**
   * @deprecated use stopScreenSharing() instead
   */
  public static stopScreenShare() {
    this.stopScreenSharing();
  }

  /**
   * @deprecated use setLayout() instead
   */
  public static setMode(
    mode: (typeof CallConstants.MODE)[keyof typeof CallConstants.MODE],
  ) {
    const layout = mode === 'DEFAULT' ? 'SIDEBAR' : mode;
    this.setLayout(layout);
  }

  /**
   * @deprecated use showVirtualBackgroundDialog() instead
   */
  public static openVirtualBackground() {
    this.showVirtualBackgroundDialog();
  }

  /**
   * @deprecated use hideVirtualBackgroundDialog() instead
   */
  public static closeVirtualBackground() {
    this.hideVirtualBackgroundDialog();
  }

  /**
   * @deprecated use setVirtualBackgroundBlurLevel() instead
   */
  public static setBackgroundBlur(blurLevel: number) {
    setVirtualBackgroundBlurLevel(blurLevel);
  }

  /**
   * @deprecated use setVirtualBackgroundImage() instead
   */
  public static setBackgroundImage(imageUrl: string) {
    setVirtualBackgroundImage(imageUrl);
  }
}
